import {
  AudioLines,
  Check,
  MessageSquareText,
  RefreshCw,
  X,
} from "lucide-react";
import classes from "../../_css/CustomButtons.module.css";

export function CustomButtonLight({
  text,
  onClick,
  fontSize = "14px",
  disabled = false,
  width = "fit-content",
  padding = "4px 18px",
  icon = null,
}) {
  return (
    <button
      style={{ fontSize, width, padding }}
      className={classes["custom-btn-light"]}
      onClick={onClick}
      disabled={disabled}
    >
      {icon === "text" && (
        <i className={classes["icon"]}>
          <MessageSquareText size={16} />
        </i>
      )}
      {icon === "voice" && (
        <i className={classes["icon"]}>
          <AudioLines size={16} />
        </i>
      )}
      {text}
    </button>
  );
}

export function CustomButtonOutlineLight({
  text,
  onClick,
  fontSize = "14px",
  disabled = false,
  width = "fit-content",
  padding = "4px 18px",
  icon = null,
}) {
  return (
    <button
      style={{ fontSize, width, padding }}
      className={classes["custom-btn-outline-light"]}
      onClick={onClick}
      disabled={disabled}
    >
      {icon === "cancel" && (
        <i className={classes["icon"]}>
          <X size={16} />
        </i>
      )}
      {text}
    </button>
  );
}

export function CustomButton({
  text,
  onClick,
  fontSize = "14px",
  disabled = false,
  width = "fit-content",
  padding = "4px 18px",
  icon = null,
}) {
  return (
    <button
      style={{ fontSize, width, padding }}
      className={classes["custom-btn"]}
      onClick={onClick}
      disabled={disabled}
    >
      {icon === "refresh" && (
        <i className={classes["icon"]}>
          <RefreshCw size={16} />
        </i>
      )}
      {icon === "tick" && (
        <i className={classes["icon"]}>
          <Check size={16} />
        </i>
      )}
      {text}
    </button>
  );
}

export function CustomButtonOutline({
  text,
  onClick,
  fontSize = "14px",
  disabled = false,
  width = "fit-content",
  padding = "4px 18px",
}) {
  return (
    <button
      style={{ fontSize, width, padding }}
      className={classes["custom-btn-outline"]}
      onClick={onClick}
      disabled={disabled}
    >
      {text}
    </button>
  );
}

export function CustomButtonDanger({
  text,
  onClick,
  fontSize = "14px",
  disabled = false,
  width = "fit-content",
  padding = "4px 18px",
}) {
  return (
    <button
      style={{ fontSize, width, padding }}
      className={classes["custom-btn-danger"]}
      onClick={onClick}
      disabled={disabled}
    >
      {text}
    </button>
  );
}

export function ToggleSwitch({
  value,
  onChange,
  outerSize = { width: 40, height: 20 },
  innerSize = { width: 16, height: 16 },
  left="21px"
}) {
  return (
    <button
      type="button"
      aria-pressed={value}
      className={classes["toggle-switch"]}
      onClick={() => onChange(!value)}
      style={outerSize}
    >
      <span
        className={classes["toggle-knob"]}
        style={{ ...innerSize, left: value ? left : "2px" }}
      />
    </button>
  );
}
